var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlert = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0.700195L14 12.7911H0L7 0.700195ZM6.57643 8.91143C6.60021 8.92745 6.62696 8.93546 6.65669 8.93546H7.45032C7.48004 8.93546 7.50382 8.92745 7.52166 8.91143C7.54543 8.89006 7.55732 8.86603 7.55732 8.83932L7.69108 5.34633C7.69108 5.31963 7.67919 5.29826 7.65541 5.28224C7.63758 5.26088 7.6138 5.2502 7.58408 5.2502H6.54076C6.51104 5.2502 6.48429 5.26088 6.46051 5.28224C6.44268 5.29826 6.43376 5.31963 6.43376 5.34633L6.54968 8.83932C6.54968 8.86603 6.5586 8.89006 6.57643 8.91143ZM6.49618 10.6739C6.63291 10.7914 6.80234 10.8502 7.00446 10.8502C7.20658 10.8502 7.37304 10.7914 7.50382 10.6739C7.63461 10.5511 7.7 10.3989 7.7 10.2173C7.7 10.0304 7.63461 9.87814 7.50382 9.76064C7.37898 9.64314 7.21253 9.58439 7.00446 9.58439C6.79639 9.58439 6.62696 9.64314 6.49618 9.76064C6.36539 9.87814 6.3 10.0304 6.3 10.2173C6.3 10.3989 6.36539 10.5511 6.49618 10.6739Z",
    fill: "#FFE664"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Alert.fa4ba7496ed6de726ee88b1db6116a73.svg";